import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@p81-common/ui';

const createClasses = makeStyles<Theme>(theme => ({
  filters_main: {
    position: 'relative',
    display: 'flex',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(3)
  },
  actions: {
    display: 'flex',
    marginBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    alignItems: 'center',
    justifyContent: 'space-between',
    '&_right': {
      display: 'flex'
    }
  },
  filter: {
    minWidth: '308px'
  },
  radio: {
    '& .MuiFormControlLabel-root': {
      margin: '0 '
    },
    '& .MuiRadio-root': {
      width: theme.spacing(2),
      height: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      marginRight: theme.spacing(1)
    },
    '& .MuiSvgIcon-root': {
      width: theme.spacing(2),
      height: theme.spacing(2)
    }
  },

  dropDown: {
    width: theme.spacing(39.75)
  },
  cancelBtn: { marginRight: theme.spacing(2) },
  rolloutBtn: {
    backgroundColor: theme.palette.error[500],
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.error[600],
      color: theme.palette.common.white
    }
  },
  wrapDG: {
    height: 'auto !important'
  },
  content: {
    paddingTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  label: {
    ...theme.typography.h6
  },
  customInputContainer: {
    marginLeft: theme.spacing(4),
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1)
  },
  customInput: {
    maxWidth: '280px'
  },
  checkbox: {}
}));

export default createClasses;
